import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules'

const el = document.querySelector('.call-for-entry-slider')
const container = el.querySelector('.swiper')

new Swiper(container, {
  modules: [A11y, Navigation],
  speed: 500,
  spaceBetween: 24,
  navigation: {
    nextEl: el.querySelector('.slider-button-next'),
    prevEl: el.querySelector('.slider-button-prev'),
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 36,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 36,
    },
    1536: {
      slidesPerView: 3,
      spaceBetween: 48,
    },
  },
})
